import { render } from "./SurveyPaidComponent.vue?vue&type=template&id=561ea40c"
import script from "./SurveyPaidComponent.vue?vue&type=script&lang=js"
export * from "./SurveyPaidComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__